import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";
import { SURQUAL_FARE_CODE_PAGE } from "./SURQUAL_FARE_CODE";

export const MAPPING_FARE_CODE_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "RATE_CODE",
  menuLabel: "RATE_CODE",
  pageLabel: "RATE_CODE_TITLE_MAPPING",
  name: "mapping_fare_code",
  path: "fare-codes",
  description: "CONF_DESC_MAPPING_RATE_CODE",
  model: {
    entityName: "datafeed",
    label: "RATE_CODE",
    path: "/api/mapping/fare-codes",
    bulkPath: "/api/mapping/fare-codes/bulk-updates",
    name: "Code Tarifaire",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "properties",
        order: 3,
        label: "PROPERTIES",
        sortable: false,
        type: FormatType.LIST,
        labelKey: "short_name",
        numberOfColumnItemsToDisplay: 2,
        tooltip: true,
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 4,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 5,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 6,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "fare_code.short_name",
        order: 7,
        label: "RATE_CODE",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/fare-codes/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.SelectMultiple,
        mustTranslateOptions: false,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "properties",
        labelKey: "hebergement_nom_court",
        label: "PROPERTIES",
        lookup: "property__in",
        controlledInputSize: true,
        numericIds: true,
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/mapping/fare-codes/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
        allowEmpty: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/fare-codes/export" },
    import: { path: "/api/mapping/fare-codes/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        key: "datafeed",
        label: "DATA_FEED_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/fare-codes/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "fare_code",
        label: "RATE_CODE",
        labelKey: "short_name",
        subCreationForm: SURQUAL_FARE_CODE_PAGE.tabs[0],
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "fare_code",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "fare_code",
        flex: "100%",
      },
    ],
  },
};
